import nene from "../../../assets/nene.png";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Modal from "react-modal";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Progress } from "../../../interfaces/progress";
import { customStyles } from "../../../theme/global";

Modal.setAppElement("#root");

const ProgressReportPortuguese = () => {
  const { progress, stage, instance_name, alerts, alert_url } = useSelector(
    (state: any) => state.milestones
  );
  const { loading } = useSelector((state: any) => state.ui);
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [backUrl, setBackUrl] = useState("");
  const history = useHistory();
  const [alert, setAlert] = useState({ type: "green", color: "#27A844" });

  useEffect(() => {
    setBackUrl(localStorage.getItem("@urihitos") || "");
  }, []);

  useEffect(() => {
    const orange = alerts.some(
      (item: any) => item.percentage >= 0 && item.percentage <= 49
    );
    const red = alerts.some(
      (item: any) => item.percentage >= 50 && item.percentage <= 100
    );
    if (red) {
      setAlert({ type: "red", color: "#D01F3C" });
    } else if (orange) {
      setAlert({ type: "orange", color: "#D15600" });
    }
  }, [alerts]);

  const afterOpenModal = () => {
    // after open modal
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const calculatePercentage = (total: number, completed: number) => {
    const calculate = (completed * 100) / total;
    return Number(calculate.toFixed(0));
  };

  return (
    <div className="page">
      <div className="container">
        <div className="row mt-5">
          <div className="col-sm-12 text-center">
            <div>
              <img src={nene} alt="Imagen niño" width="200" height="auto" />
              <div className="report2-name-child">
                <h2>{instance_name}</h2>
              </div>
            </div>
            <div>
              <h1>Relatório de conquistas alcançadas</h1>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        ) : stage.name ? (
          <div className="row mt-2">
            <div className="col-sm-12 text-center my-3">
              <img
                src={stage.image_url}
                alt={stage.name}
                width="200"
                height="auto"
              />
              <p className="mt-2">{stage.name.toUpperCase()}</p>
            </div>
          </div>
        ) : (
          <div className="alert alert-info mt-4 mb-4 text-center">
            Nenhum dado encontrado
          </div>
        )}

        <div className="row mt-5">
          <div className="col-sm-12">
            <h3 className="text-center">Conquistas concluídas por área</h3>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        ) : progress.length > 0 ? (
          <div className="row mt-4">
            {progress.map((item: Progress) => (
              <div className="col-sm-4 text-center" key={item.area.id}>
                <div style={{ width: 200, height: 200, margin: "10px auto" }}>
                  <CircularProgressbar
                    value={calculatePercentage(item.area_total, item.completed)}
                    text={`${calculatePercentage(
                      item.area_total,
                      item.completed
                    )}%`}
                  />
                </div>
                <h4 className="mt-3">{item.area.name}</h4>
                <img
                  src={item.area.image_url}
                  alt={item.area.name}
                  className="mt-4 icon-report2"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="alert alert-info text-center mt-4">
            Nenhum dado encontrado
          </div>
        )}

        <div className="row text-center mt-5">
          <div className="col-sm-12 my-3">
            {backUrl && (
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => history.push(backUrl)}
                style={{ width: "220px" }}
              >
                Editar
              </button>
            )}
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => window.location.reload()}
              style={{ width: "220px" }}
            >
              Atualizar
            </button>
          </div>
        </div>

        <div className="row text-center mt-5">
          <div className="col-sm-12">
            <p style={{ fontWeight: 600, fontSize: 14 }}>
              Estimulación temprana
            </p>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h5>Relatório dos marcos do desenvolvimento</h5>
        <hr />
        <div
          style={{
            backgroundColor: alert.color,
            padding: 10,
            boxShadow: "0 0 5px 0 rgba(0,0,0,.5)",
          }}
        >
          <div
            style={{
              lineHeight: "1.6em",
              fontSize: 14,
              color: "white",
              fontWeight: 600,
            }}
          >
            {alert.type === "green" && (
              <>
                <strong>Parabéns!</strong> De acordo com as respostas que você
                nos deu, seu/sua filho/filha está alcançando muitas conquistas e
                progrediu em seu desenvolvimento de acordo com a média das
                crianças de sua idade. No relatório, você pode ver os detalhes
                do seu progresso.
              </>
            )}

            {alert.type === "orange" && (
              <>
                <p>
                    Muitos dos pequeninos da idade do seu filho alcançaram esses marcos..
                </p>

                <ul
                  style={{
                    fontSize: "12px",
                    margin: 0,
                    padding: 0,
                    lineHeight: "1.3em",
                  }}
                >
                  {alerts.map((item: any) => (
                    <li
                      style={{ margin: "10px 0", padding: 0 }}
                      key={item.milestone_config}
                    >
                      <i
                        className="fa fa-circle"
                        style={{ color: "white", fontSize: "10px" }}
                      ></i>{" "}
                      {item.question}
                    </li>
                  ))}
                </ul>
                <p>
                    Preste atenção especial a esses marcos e ao progresso do desenvolvimento do seu filho
                </p>
                <p>
                    <b>ATENÇÃO:</b> Se o seu pequeno já completou um marco que é mostrado no Alerta, ignore esta mensagem.
                </p>
              </>
            )}

            {alert.type === "red" && (
              <>
                <p>
                  De acordo com a sua resposta, seu/sua filho/filha ainda não
                  alcançou
                </p>

                <ul
                  style={{
                    fontSize: "12px",
                    margin: 0,
                    padding: 0,
                    lineHeight: "1.3em",
                  }}
                >
                  {alerts.map((item: any) => (
                    <li
                      style={{ margin: "10px 0", padding: 0 }}
                      key={item.milestone_config}
                    >
                      <i
                        className="fa fa-circle"
                        style={{ color: "white", fontSize: "10px" }}
                      ></i>{" "}
                      {item.question}
                    </li>
                  ))}
                </ul>
                <p>
                  A maioria das crianças a idade de seu/sua filho/filha alcançou
                  essas habilidades. Preste atenção especial e consulte o quanto
                  antes possível no centro de saúde ou pediatra sobre o
                  desenvolvimento do seu/sua filho/filha.
                </p>
                <p>
                  <b>ATENÇÃO: </b>Se a sua criança demonstrar alguma habilidade
                  mostrada no alerta, desconsidere esta mensagem.
                </p>
              </>
            )}
          </div>
        </div>
        <div className="mt-2">
          {alert_url !== "" && (
            <a href={alert_url} className="btn btn-warning btn-block mb-2">
              De volta a
            </a>
          )}
          <button
            className="btn btn-outline-primary btn-sm btn-block"
            onClick={closeModal}
          >
            Fechar
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ProgressReportPortuguese;
